export const ADMINEARNING_DATA_GET="ADMINEARNING_DATA_GET"
export const ADMINEARNING_DATA_SUCCESS="ADMINEARNING_DATA_SUCCESS"

//  EARNING MANUFACTURED PRODUCT
export const ADMINEARNING_MP_DATA_GET="ADMINEARNING_MP_DATA_GET"
export const ADMINEARNING_MP_DATA_SUCCESS="ADMINEARNING_MP_DATA_SUCCESS"
